export default __webpack_public_path__ + "static/ssomenthal-019258470afcf8325caebccddbdea7fd.jpg";